"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/OnCall/DesktopMoreOptionsModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Modals = require('web/components/VideoCall/Modals');
var _uiUtils = require('web/components/VideoCall/OnCall/uiUtils');

const noEvents = []










const DesktopMoreOptionsModal = ({
  ignoredUIEvents = noEvents,
  isOpen, onClose,
  onRoomLinkCopy,
  onOpenSettings, onOpenNetstats,
}) => {
  const rootRef = _uiUtils.useStopPropagation.call(void 0, ignoredUIEvents)

  const rootClassName = _classBuilder2.default.call(void 0, 
    "meeting--on-call--desktop-more-modal",
    { hidden: !isOpen },
  )

  return (
    _react2.default.createElement('div', { className: rootClassName, ref: rootRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
      , _react2.default.createElement(_Modals.MoreOptionsMenu, {
        onClose: onClose,
        onRoomLinkCopy: onRoomLinkCopy,
        onOpenSettings: onOpenSettings,
        isNetstatsLinkEnabled: true,
        onOpenNetstats: onOpenNetstats, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
      )
      , _react2.default.createElement('div', { onClick: onClose, className: "meeting--modal--close-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}} )
    )
  )
}

exports. default = DesktopMoreOptionsModal
